const includesSurname = (name) =>
  name &&
  /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/i.test(
    name.split('')[name.length - 1] === ' ' ? name.slice(0, -1) : name
  );

export default includesSurname;
